module.exports = __webpack_public_path__ + "static/avril-silly-778e35400def931e602f57c6cd022b7f.gif";